export enum EffectLoadingState {
    Init = 'Init',
    Loading = 'Loading',
    Loaded = 'Loaded',
    HasErrors = 'HasErrors',
}

export interface EffectErrorState {
    errorMessage: string;
}

export type EffectState = EffectLoadingState | EffectErrorState;
